module.exports = __webpack_public_path__ + "img/dsci0092.763bf4fe.jpg";